import styled from 'styled-components';

export const Wrapper = styled.div`
  text-align: left;
`;

export const Line = styled.div`
  height: 1px;
  background-color: #0f3a39;
`;

export const Small = styled.p`
  margin: 16px 0;
  font-size: 10px;
  line-height: 15px;
  color: var(--text-light);
`;
